const Filters = {};

Filters.dict = (path, value) => {
  const getList = value === undefined;
  // 获取读取字段的参数，参数值，用于查询参数名 。

  let dictObj = CONST_DICT;
  _.each(path, (way) => {
    dictObj = _.get(dictObj, way);
  });

  const dict = [];
  for (const [k, v] of Object.entries(dictObj)) {
    if (v && v.value && v.label) {
      dict.push({
        label: v.label,
        labelKey: `___${k}`,
        value: v.value,
        valueKey: k,
      });
    }
  }

  if (getList) {
    return dict;
  }

  const item = _.find(dict, { value }) || _.find(dict, { value: 1 * value });
  return item ? item.label : value;
};

export default Filters;
